<template>
  <el-form label-width="0" inline>
    <el-form-item style="width: 280px">
      <el-checkbox :value="obj.DMN_SEAPORT" :label="$t('Menu.Harbour')" disabled style="width: 200px" />
      <el-button v-if="!obj.DMN_SEAPORT" @click="initClickHandler('DMN_SEAPORT')">{{ $t('Menu.Initialize') }}</el-button>
    </el-form-item>
    <el-form-item style="width: 280px">
      <el-checkbox :value="obj.DMN_AIRPORT" :label="$t('Menu.Airport')" disabled style="width: 200px" />
      <el-button v-if="!obj.DMN_AIRPORT" @click="initClickHandler('DMN_AIRPORT')">{{ $t('Menu.Initialize') }}</el-button>
    </el-form-item>
    <br>
    <el-form-item style="width: 280px">
      <el-checkbox :value="obj.DMN_CHARGE_ITEM" :label="$t('Menu.ChargesItems')" disabled style="width: 200px" />
      <el-button v-if="!obj.DMN_CHARGE_ITEM" @click="initClickHandler('DMN_CHARGE_ITEM')">{{ $t('Menu.Initialize') }}</el-button>
    </el-form-item>
    <el-form-item style="width: 280px">
      <el-checkbox :value="obj.DMN_REGION" :label="$t('Menu.AirRoute')" disabled style="width: 200px" />
      <el-button v-if="!obj.DMN_REGION" @click="initClickHandler('DMN_REGION')">{{ $t('Menu.Initialize') }}</el-button>
    </el-form-item>
    <br>
    <el-form-item style="width: 280px">
      <el-checkbox :value="obj.DMN_NETWORK" :label="$t('Menu.NetWork')" disabled style="width: 200px" />
      <el-button v-if="!obj.DMN_NETWORK" @click="initClickHandler('DMN_NETWORK')">{{ $t('Menu.Initialize') }}</el-button>
    </el-form-item>
    <el-form-item style="width: 280px">
      <el-checkbox :value="obj.DMN_CURRENCY" :label="$t('Menu.Currency')" disabled style="width: 200px" />
      <el-button v-if="!obj.DMN_CURRENCY" @click="initClickHandler('DMN_CURRENCY')">{{ $t('Menu.Initialize') }}</el-button>
    </el-form-item>
    <br>
    <el-form-item style="width: 280px">
      <el-checkbox :value="obj.DMN_EQ_TYPE" :label="$t('Menu.EQType')" disabled style="width: 200px" />
      <el-button v-if="!obj.DMN_EQ_TYPE" @click="initClickHandler('DMN_EQ_TYPE')">{{ $t('Menu.Initialize') }}</el-button>
    </el-form-item>
    <el-form-item style="width: 280px">
      <el-checkbox :value="obj.DMN_PACKING" :label="$t('Menu.Packing')" disabled style="width: 200px" />
      <el-button v-if="!obj.DMN_PACKING" @click="initClickHandler('DMN_PACKING')">{{ $t('Menu.Initialize') }}</el-button>
    </el-form-item>
    <br>
    <el-form-item style="width: 280px">
      <el-checkbox :value="obj.DMN_HOUSE_BL_TYPE" :label="$t('Menu.HouseBlType')" disabled style="width: 200px" />
      <el-button v-if="!obj.DMN_HOUSE_BL_TYPE" @click="initClickHandler('DMN_HOUSE_BL_TYPE')">{{ $t('Menu.Initialize') }}</el-button>
    </el-form-item>
    <el-form-item style="width: 280px">
      <el-checkbox :value="obj.DMN_CARGO_TYPE" :label="$t('Menu.CargoType')" disabled style="width: 200px" />
      <el-button v-if="!obj.DMN_CARGO_TYPE" @click="initClickHandler('DMN_CARGO_TYPE')">{{ $t('Menu.Initialize') }}</el-button>
    </el-form-item>
    <br>
    <el-form-item style="width: 280px">
      <el-checkbox :value="obj.DMN_INCO_TERM" :label="$t('Menu.IncoTerm')" disabled style="width: 200px" />
      <el-button v-if="!obj.DMN_INCO_TERM" @click="initClickHandler('DMN_INCO_TERM')">{{ $t('Menu.Initialize') }}</el-button>
    </el-form-item>
    <el-form-item style="width: 280px">
      <el-checkbox :value="obj.DMN_SHIPPING_TERM" :label="$t('Menu.ShippingTerm')" disabled style="width: 200px" />
      <el-button v-if="!obj.DMN_SHIPPING_TERM" @click="initClickHandler('DMN_SHIPPING_TERM')">{{ $t('Menu.Initialize') }}</el-button>
    </el-form-item>
    <br>
    <el-form-item style="width: 280px">
      <el-checkbox :value="obj.SYS_TRADE_TERM" :label="$t('Menu.TradeTerm')" disabled style="width: 200px" />
      <el-button v-if="!obj.SYS_TRADE_TERM" @click="initClickHandler('SYS_TRADE_TERM')">{{ $t('Menu.Initialize') }}</el-button>
    </el-form-item>
    <el-form-item style="width: 280px">
      <el-checkbox :value="obj.SYS_CUSTOMER_TYPE" :label="$t('Menu.CustomerType')" disabled style="width: 200px" />
      <el-button v-if="!obj.SYS_CUSTOMER_TYPE" @click="initClickHandler('SYS_CUSTOMER_TYPE')">{{ $t('Menu.Initialize') }}</el-button>
    </el-form-item>
    <br>
    <el-form-item style="width: 280px">
      <el-checkbox :value="obj.PRC_PORT_GROUP" :label="$t('Menu.PortGroup')" disabled style="width: 200px" />
      <el-button v-if="!obj.PRC_PORT_GROUP" @click="initClickHandler('PRC_PORT_GROUP')">{{ $t('Menu.Initialize') }}</el-button>
    </el-form-item>
    <el-form-item style="width: 280px">
      <el-checkbox :value="obj.SYS_OTHER_CHARGE_ITEM" :label="$t('Menu.OtherChargeItem')" disabled style="width: 200px" />
      <el-button v-if="!obj.SYS_OTHER_CHARGE_ITEM" @click="initClickHandler('SYS_OTHER_CHARGE_ITEM')">{{ $t('Menu.Initialize') }}</el-button>
    </el-form-item>
    <br>
    <el-form-item style="width: 280px">
      <el-checkbox :value="obj.SYS_OTHER_CHARGE_ITEM" :label="$t('Menu.BusinessStatus')" disabled style="width: 200px" />
      <el-button v-if="!obj.SYS_OTHER_CHARGE_ITEM" @click="initClickHandler('SYS_OTHER_CHARGE_ITEM')">{{ $t('Menu.Initialize') }}</el-button>
    </el-form-item>
    <el-form-item style="width: 280px">
      <el-checkbox :value="obj.SYS_OTHER_CHARGE_ITEM" :label="$t('Menu.PermissionConfig')" disabled style="width: 200px" />
      <el-button v-if="!obj.SYS_OTHER_CHARGE_ITEM" @click="initClickHandler('SYS_OTHER_CHARGE_ITEM')">{{ $t('Menu.Initialize') }}</el-button>
    </el-form-item>
    <br>
    <el-form-item style="width: 280px">
      <el-checkbox :value="obj.SYS_OTHER_CHARGE_ITEM" :label="$t('Menu.Report')" disabled style="width: 200px" />
      <el-button v-if="!obj.SYS_OTHER_CHARGE_ITEM" @click="initClickHandler('SYS_OTHER_CHARGE_ITEM')">{{ $t('Menu.Initialize') }}</el-button>
    </el-form-item>
    <el-form-item style="width: 280px">
      <el-checkbox :value="obj.SYS_CUSTOMER_TYPE" :label="$t('Menu.ConfigurationManagement')" disabled style="width: 200px" />
      <el-button v-if="!obj.SYS_CUSTOMER_TYPE" @click="initClickHandler('SYS_CUSTOMER_TYPE')">{{ $t('Menu.Initialize') }}</el-button>
    </el-form-item>
    <br>
    <el-form-item style="width: 280px">
      <el-checkbox :value="obj.CODE_MODULE" :label="$t('Menu.ShippingCompaniesAirlines')" disabled style="width: 200px" />
      <el-button v-if="!obj.CODE_MODULE" @click="initClickHandler('CODE_MODULE')">{{ $t('Menu.Initialize') }}</el-button>
    </el-form-item>
    <el-form-item style="width: 280px">
      <el-checkbox :value="obj.COUNTRY" :label="$t('Menu.Template')" disabled style="width: 200px" />
      <el-button v-if="!obj.COUNTRY" @click="initClickHandler('SYS_TEMPLATE','COUNTRY')">{{ $t('Menu.Initialize') }}</el-button>
    </el-form-item>
    <br>
    <el-form-item style="width: 280px">
      <el-checkbox :value="obj.SYS_SEQUENCE" :label="$t('Menu.Sequence')" disabled style="width: 200px" />
      <el-button v-if="!obj.SYS_SEQUENCE" @click="initClickHandler('SYS_SEQUENCE')">{{ $t('Menu.Initialize') }}</el-button>
    </el-form-item>
    <el-form-item style="width: 280px">
      <el-checkbox :value="obj.DMN_BL_MODE" :label="$t('Menu.BlMode')" disabled style="width: 200px" />
      <el-button v-if="!obj.DMN_BL_MODE" @click="initClickHandler('SYS_TEMPLATE','DMN_BL_MODE')">{{ $t('Menu.Initialize') }}</el-button>
    </el-form-item>
    <br>
    <el-form-item style="width: 280px">
      <el-checkbox :value="obj.DMN_CUSTOM_JOB_TYPE" :label="$t('Menu.CustomJobType')" disabled style="width: 200px" />
      <el-button v-if="!obj.DMN_CUSTOM_JOB_TYPE" @click="initClickHandler('DMN_CUSTOM_JOB_TYPE')">{{ $t('Menu.Initialize') }}</el-button>
    </el-form-item>
    <el-form-item style="width: 280px">
      <el-checkbox :value="obj.DMN_TRANSMIT_FILE_TYPE" :label="$t('Menu.TransmitFileType')" disabled style="width: 200px" />
      <el-button v-if="!obj.DMN_TRANSMIT_FILE_TYPE" @click="initClickHandler('DMN_TRANSMIT_FILE_TYPE')">{{ $t('Menu.Initialize') }}</el-button>
    </el-form-item>
    <br>
    <el-form-item style="width: 280px">
      <el-checkbox :value="obj.PRC_AIR_SERVICE" :label="$t('Menu.AirService')" disabled style="width: 200px" />
      <el-button v-if="!obj.PRC_AIR_SERVICE" @click="initClickHandler('PRC_AIR_SERVICE')">{{ $t('Menu.Initialize') }}</el-button>
    </el-form-item>
    <el-form-item style="width: 280px">
      <el-checkbox :value="obj.DOCUMENTCATEGORY" :label="$t('Menu.documentCategory')" disabled style="width: 200px" />
      <el-button v-if="!obj.DOCUMENTCATEGORY" @click="initClickHandler('DOCUMENTCATEGORY')">{{ $t('Menu.Initialize') }}</el-button>
    </el-form-item>
    <br>
    <el-form-item style="width: 280px">
      <el-checkbox :value="obj.SINGLEONLINESET" :label="$t('Menu.SingleOnlineSet')" disabled style="width: 200px" />
      <el-button v-if="!obj.SINGLEONLINESET" @click="initClickHandler('SINGLEONLINESET')">{{ $t('Menu.Initialize') }}</el-button>
    </el-form-item>
    <el-form-item style="width: 280px">
      <el-checkbox :value="obj.DMN_CHARGE_UNIT" :label="$t('Menu.charegeUnit')" disabled style="width: 200px" />
      <el-button v-if="!obj.DMN_CHARGE_UNIT" @click="initClickHandler('DMN_CHARGE_UNIT')">{{ $t('Menu.Initialize') }}</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import * as initalDataApi from '@/api/sysManage/baseConfig/initalData'

export default {
  name: 'InitDataGroup',
  components: { cargoAdvanceSelect },
  props: {
    obj: { type: Object, required: true }
  },
  data() {
    return {
      innerVisible: false,
      selectTypeNames: TYPE_NAMES,
      cboTenantId: null
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    initClickHandler(tableName, typeName) {
      const param = {}
      if (typeName) {
        param[typeName] = this.obj[typeName]
      } else {
        param[tableName] = this.obj[tableName]
      }
      param.TENANT_ID = this.obj.TENANT_ID
      param.COPY_TENANT_ID = this.obj.COPY_TENANT_ID
      param.uuid = this.obj.uuid
      const loading = getLoading()
      initalDataApi.updateInitalData(param).then(resp => {
        Object.assign(this.obj, resp.data)
      }).finally(() => loading.close())
    },
    closeHandler() {
      this.cboTenantId = ''
      this.$emit('close')
    }
  }
}
</script>

<style scoped>

</style>
